import React from "react";
import {Formik, Form} from "formik";
import * as Yup from "yup";
import Modal from "../../../components/Modal";
import InputText from "../../../components/Inputs/InputText";
import InputPassword from "../../../components/Inputs/InputPassword";
import Button from "../../../components/Button";
import {AdminUser} from "../../../interfaces/admin";
import localStyles from "../styles.module.scss";

interface UserFormProps {
    user?: AdminUser;
    onSubmit: (values: {username: string; password: string; is_admin: boolean}) => void;
    onCancel: () => void;
}

const UserForm = ({user, onSubmit, onCancel}: UserFormProps) => {
    const isEdit = !!user;

    const validationSchema = Yup.object().shape({
        username: Yup.string().min(3, "Min 3 characters").required("Username is required"),
        password: isEdit
            ? Yup.string().min(3, "Min 3 characters")
            : Yup.string().min(3, "Min 3 characters").required("Password is required"),
        is_admin: Yup.boolean(),
    });

    return (
        <Formik
            initialValues={{
                username: user?.username ?? "",
                password: "",
                is_admin: user?.is_admin ?? false,
            }}
            validationSchema={validationSchema}
            onSubmit={(values) => {
                onSubmit(values);
            }}
        >
            {({errors, touched, values, isSubmitting, setFieldValue, submitForm}) => (
                <Modal
                    show
                    handleClose={() => onCancel()}
                    width={450}
                    closeOut
                    element={
                        <div>
                            <div className={localStyles.modalTitle}>
                                {isEdit ? "Edit User" : "Create User"}
                            </div>
                            <Form>
                                <div className={localStyles.modalBody}>
                                    <InputText
                                        id="username"
                                        labelText="Username"
                                        placeholder="Username"
                                        value={values.username}
                                        handleChange={(value: string) => setFieldValue("username", value)}
                                        errorMessage={touched.username && errors.username ? errors.username : ""}
                                    />

                                    <InputPassword
                                        id="password"
                                        labelText={isEdit ? "Password (leave empty to keep current)" : "Password"}
                                        placeholder="Password"
                                        value={values.password}
                                        handleChange={(value: string) => setFieldValue("password", value)}
                                        errorMessage={touched.password && errors.password ? errors.password : ""}
                                    />

                                    <div className={localStyles.checkboxGroup}>
                                        <input
                                            type="checkbox"
                                            id="is_admin"
                                            checked={values.is_admin}
                                            onChange={(e) => setFieldValue("is_admin", e.target.checked)}
                                        />
                                        <label htmlFor="is_admin">Administrator</label>
                                    </div>
                                </div>

                                <div className={localStyles.modalFooter}>
                                    <Button
                                        id="user-form-cancel"
                                        size="small"
                                        background="bg-outline-grey"
                                        text="Cancel"
                                        click={() => onCancel()}
                                    />
                                    <Button
                                        id="user-form-submit"
                                        size="small"
                                        background="bg-primary"
                                        text={isEdit ? "Update" : "Create"}
                                        type="submit"
                                        disabled={isSubmitting}
                                    />
                                </div>
                            </Form>
                        </div>
                    }
                />
            )}
        </Formik>
    );
};

export default UserForm;
